<template>
  <div class="main_home">
    <div class="describe">
      <div class="describe__left">
        <div class="title">公司简介</div>
        <div class="content">
          广州粤桥工程咨询有限公司，系依托华南理工大学土木与交通资深教授专家团队，为实现科研成果产业转化而成立的高科技企业。基于团队超过20年的科研基础，公司在结构精细化仿真、结构全寿命周期监测、工程信息化等领域，为各类大型工程提供全方位的技术咨询服务。公司业务立足广东辐射华南，竭诚为土木行业高质量发展贡献力量。
        </div>
        <Button
          type="primary"
          shape="circle"
          class="btn"
          @click="linkToNewNav('about_us')"
        >
          了解更多
          <Icon type="md-arrow-forward" />
        </Button>
      </div>
      <div class="describe__right">
        <img
          src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeDescribe_bg.png"
        />
      </div>
    </div>
    <div class="product">
      <div class="product__title">业务介绍</div>
      <div class="product__describe">
        我们在结构精细化仿真、结构全寿命周期监测、工程信息化等领域，为各类大型工程项目提供全方位的技术咨询服务
      </div>
      <div class="product__img">
        <div
          v-for="item in producetList"
          :key="item.key"
          class="items"
          @click="linkToNewNav(item.key)"
        >
          <img class="imgs" :src="item.bgImg" />
          <div class="text">
            <div class="icon">
              <img :src="item.img" width="100%"/>
            </div>
            <div class="produce_des">{{ item.des }}</div>
            <Button shape="circle" class="btn">
              了解更多
              <Icon type="md-arrow-forward" />
            </Button>
          </div>
        </div>
      </div>
    </div>
    <div class="projectList">
      <div class="projectList__title">项目展示</div>
      <div class="contentBox">
        <ul class="achievements">
          <li v-for="(item, index) in achList" :key="index" @click="linkToProjectlist(item.key)">
            <div class="ache_box">
              <img :src="item.img" alt="图片加载失败" />
              <div class="achDes">{{item.title}}</div>
              <button class="achBtn">了解更多<Icon type="md-arrow-forward" size="24" style="margin-left: 5px;"/></button>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--
    <div class="projectList2">
      <div class="projectList2__title">项目展示</div>
      <div class="contentBox">
        <ul class="achievements">
          <li v-for="(item, index) in achList" :key="index" @click="linkToProjectlist(item.key)">
            <div class="ache_box">
              <img :src="item.img" alt="图片加载失败" class="projectList2_img" />
            </div>
            <div class="block">
              <div class="achDes">{{item.title}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    -->
    <div style="position:fixed;bottom:30px;right:30px;cursor:pointer;" v-show="isMobile?true:(cur_index>0)" @click="toPlatform">
      <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeFlow.png" alt="" width="150px">
    </div>
  </div>
</template>
<script>
export default {
  name: 'main_home',
  data() {
    return {
      achList: [
        {
          class: '工程结构仿真实例',
          key: 'ana',
          title: "工程结构仿真项目",
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/home_ach1.png'
        },
        {
          class: '工程智能监测实例',
          key: 'moni',
          title: "工程智能监测项目",
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/home_ach2.png'
        },
        {
          class: '工程信息科技实例',
          key: 'tech',
          title: "工程信息科技项目",
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/home_ach3.png'
        },
        // {
        //   class: '工程结构研发实例',
        //   key: 'dev',
        //   title: "工程结构研发类项目业绩",
        //   img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/home_ach4.png'
        // }
      ],
      producetList: [
        {
          key: "struct_analyse",
          bgImg: "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeBusiness_bg1.jpg",
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ana_icon.png',
          des: "工程结构仿真"
        },
        {
          key: "struct_moni",
          bgImg: "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeBusiness_bg2.jpg",
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/moni_icon.png',
          des: "工程智能监测"
        },
        {
          key: "struct_tech",
          bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeBusiness_bg3.jpg',
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/tech_icon.png',
          des: "工程信息科技"
        },
        // {
        //   key: "struct_dev",
        //   bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeBusiness_bg4.jpg',
        //   img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/dev_icon.png',
        //   des: "工程科技研发"
        // }
      ],
      cur_index: 0,
      invoke: false,
      list: [],
      isinit: false,
      portHeight: '100vh'
    }
  },
  computed: {
    isMobile(){
      if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
        return true
      }
      else{
        return false
      }
    }
  },
  created() {
    this.$emit('changeProduce','main_home')
    this.isinit = false
    this.portHeight = this.isMobile?'80vh':'100vh'
  },
  mounted() {
    const _this = this
    // window.location.reload()
    window.addEventListener('mousewheel', this.WheelGo, { passive: false })
    this.list = [
      { ele: 'carousel' },
      { ele: 'describe' },
      { ele: 'product' },
      { ele: 'projectList' },
      // { ele: 'projectList2' },
      // { ele: 'partner' },
      { ele: 'footer' }
    ]
    document.querySelector('body').addEventListener('mouseover' ,this.initSrollPosition)
    // this.list = this.initSrollPosition('body', this.list)
    let carousel = document.getElementsByClassName('carousel')[0]
    carousel.onmouseover = function() {
      _this.$emit('back',false)
    }
    carousel.onmouseout = function() {
      _this.$emit('back',true)
    }
  },
  methods: {
    handleOpenPages(val) {
      window.open(val)
    },
    // 跳转产品中心子菜单
    linkToNewNav(val) {
      this.$emit('changeProduce', val)
    },
    linkToProjectlist(id) {
      this.$emit('changeProduce', 'projectList', id)
    },
    toPlatform() {
      window.open('https://cloud.yueq.com.cn/')
    },
    initSrollPosition() {
      if(!this.isinit){
        for (let i in this.list) {
          this.list[i].position = document.querySelector("."+this.list[i].ele).offsetTop
        }
        this.isinit = true
      }
    },
    stopDefault(e) {
      e.preventDefault()
      return false
    },
    WheelGo(e) {
      // 判断向上滚动还是向下滚动
      var isDown = e.deltaY > 0 ? true : false

      this.stopDefault(e)
      if (this.invoke) {
        return
      }
      this.moveTo(isDown)
    },
    moveTo(isDown) {
      var cur_state
      if (isDown) {
        this.cur_index = this.cur_index >= this.list.length - 1 ? this.list.length - 1 : this.cur_index + 1
        cur_state = this.list[this.cur_index]
      } else {
        this.cur_index = this.cur_index <= 0 ? 0 : this.cur_index - 1
        cur_state = this.list[this.cur_index]
      }
      // console.log("invoke")
      // console.log(this.list)
      this.invoke = true
      // console.log(this.cur_index)
      window.scrollTo({ top: cur_state.position, left: 0, behavior: "smooth" })
      if(this.cur_index == 2){
        document.querySelector('.header_name').setAttribute('style', 'color:#000;')
        document.querySelector('.selected').setAttribute('style', 'color:#000;')
        // console.log(document.querySelector('.header_name'))
      }
      else{
        document.querySelector('.header_name').setAttribute('style', 'color:#FFF;')
        document.querySelector('.selected').setAttribute('style', 'color:#FFF;')
      }
      // if(this.cur_index == 0){
      //   document.querySelector('.header--home').setAttribute('position', 'absolute')
      // }
      // else{
      //   document.querySelector('.header--home').setAttribute('position', 'fixed')
      // }
      setTimeout(() => {
        this.invoke = false
      }, 500)
    }
  },
  beforeDestroy() {
    window.removeEventListener('mousewheel', this.WheelGo)
    document.querySelector('body').removeEventListener('mouseover',this.initSrollPosition)
  },
};
</script>
<style lang="less" scoped>
.main_home {
  .describe {
    display: flex;
    width: 100%;
    height: 100vh;
    &__left {
      width: 50%;
      height: 100%;
      padding: 0 100px;
      background-color: #2e2e30;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #fff;
      .title {
        position: relative;
        font-size: 36px;
        line-height: 1.5em;
        font-weight: bold;
      }
      .title::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 0;
        width: 80px;
        height: 8px;
        background-color: #1677ff;
      }
      .content {
        margin: 64px 0px 56px;
        font-size: 14px;
        line-height: 2em;
        color: #d3d3d3;
      }
      .btn {
        width: 168px;
        transition: all 0.3s;
      }
    }
    &__right {
      width: 50%;
      height: 100%;
    }
    &__right img {
      width: 100%;
      height: 100%;
    }
  }
  .product {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #000;
    &__title {
      margin: 86px 0 32px;
      position: relative;
      font-size: 36px;
      line-height: 1.5em;
      font-weight: bold;
    }
    &__title::after {
      content: "";
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 8px;
      background-color: #1677ff;
    }
    &__describe {
      margin-bottom: 40px;
      width: 744px;
      font-size: 14px;
      line-height: 2em;
      text-align: center;
    }
    &__img {
      width: 100%;
      display: flex;
      justify-content: center;
      .items {
        width: 33.3%;
        height: 480px;
        position: relative;
        cursor: pointer;
        transition: all 0.4s ease-out;
        color: #fff;
        background-color: #000;
        .imgs {
          width: 100%;
          height: 100%;
          position: absolute;
          opacity: 0.68;
        }
        .text {
          width: 100%;
          height: 100%;
          position: absolute;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .btn {
            margin-top: 32px;
            color: #2d8cf0;
            opacity: 0;
          }
        }
        .icon {
          width: 64px;
          height: 64px;
        }
        .spicon{
          width: 100px;
          height: 64px;
        }
        .produce_des {
          margin-top: 16px;
          font-size: 24px;
          line-height: 1.5em;
          font-weight: bold;
        }
      }
    }
    .items:hover {
      background-color: #044aad;
      opacity: 0.79;
    }
    .items:hover .btn {
      opacity: 1;
    }
  }
  .projectList {
    width: 100%;
    height: 100vh;
    margin: 176px 0 0;
    padding: 64px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeAchievement_bg.png")
      center center no-repeat;
    background-size: 100% 100%;
    &__title {
      margin: 0 0 32px;
      position: relative;
      font-size: 36px;
      line-height: 1.5em;
      font-weight: bold;
      color: #fff;
    }
    &__title::after {
      content: "";
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 8px;
      background-color: #1677ff;
    }
    &__tab {
      margin-bottom: 32px;
      padding: 8px 16px;
      background-color: #1677ff;
      border-radius: 32px;
      font-size: 16px;
      line-height: 1.5em;
      color: #fff;
    }
    .contentBox {
      width: 100%;
      height: calc(100% - 128px - 54px + 100px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      .achievements {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        margin: 20px 0;
        justify-content: space-evenly;
        li {
          display: flex;
          flex-direction: column;
          width: 23%;
          padding: 16px;
          border-radius: 15px;
          background-color: #FFF;
          border: 1px solid #CCC;
          .ache_box{
            width: 100%;
            min-height: 400px;
            position: relative;
            img{
              width: 100%;
              height: 200px;
            }
            .achDes{
              margin-top: 20px;
              width: 100%;
              display: block;
              font-size: 20px;
              line-height: 1.5em;
              color: #000;
              font-weight: bold;
              text-align: center;
            }
            .achBtn{
              position: absolute;
              bottom: 40px;
              left: 50%;
              transform: translateX(-50%);
              width: 150px;
              margin: 0 auto;
              padding: 10px;
              border-radius: 15px;
              border: 1px solid #CCC;
              background-color: #FFF;
              font-size: 16px;
              line-height: 1.5em;
            }
            .achBtn:hover{
              background-color: #1677ff;
              color: #FFF;
              cursor: pointer;
            }
          }
          // display: flex;
          // flex-direction: column;
          // width: 40%;
          // border: 1px solid #CCC;
          // margin: 16px;
          // position: relative;
          // img {
          //   height: 300px;
          //   display: block;
          //   width: 100%;
          //   border: 1px solid #CCC;
          // }
          // .achDes{
          //   padding: 16px;
          //   width: 100%;
          //   height: 300px;
          //   display: none;
          //   position: absolute;
          //   text-align: center;
          //   font-size: 24px;
          //   font-weight: bold;
          //   line-height: 300px;
          //   color: #000;
          //   background-color: rgba(255, 255, 255, .2);
          // }
        }
        // li:hover .achDes{
        //   // transition: all 0.3s;
        //   // transform: scale(1.15);
        //   cursor: pointer;
        //   display: block;
        // }
        li:hover{
          transition: all 0.3s;
          transform: scale(1.1);
        }
      }
    }
  }
  .projectList2 {
    width: 100%;
    height: 100vh;
    margin: 176px 0 0;
    padding: 64px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("https://scut-officialwebsite.oss-cn-guangzhou.aliyuncs.com/homeNewBg.png")
      center center no-repeat;
    background-size: 100% 100%;
    &__title {
      margin: 0 0 32px;
      position: relative;
      font-size: 36px;
      line-height: 1.5em;
      font-weight: bold;
      color: #fff;
    }
    &__title::after {
      content: "";
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 8px;
      background-color: #1677ff;
    }
    &__tab {
      margin-bottom: 32px;
      padding: 8px 16px;
      background-color: #1677ff;
      border-radius: 32px;
      font-size: 16px;
      line-height: 1.5em;
      color: #fff;
    }
    .contentBox {
      width: 100%;
      height: calc(100% - 128px - 54px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      .achievements {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        margin: 20px 0;
        justify-content: space-evenly;
        li {
          display: flex;
          flex-direction: column;
          width: 25%;
          // padding: 16px;
          border-radius: 15px;
          // background-color: #FFF;
          // border: 1px solid #CCC;
          position: relative;
          .ache_box{
            width: 100%;
            // min-height: 400px;
            .projectList2_img{
              width: 100%;
              height: 400px;
              cursor: pointer;
            }
          }
          .block{
            opacity: 0;
            height: 400px;
            width: 100%;
            position: absolute;
            top: 400px;
            left: 0;
            background-color: rgba(255, 255, 255, .1);
            .achDes{
              margin-top: 20px;
              width: 100%;
              height: 100%;
              display: block;
              font-size: 20px;
              line-height: 350px;
              color: #000;
              font-weight: bold;
              text-align: center;
            }
          }
        }
        .ache_box:hover + .block{
          animation: blockmove 0.5s forwards;
        }
      }
    }
  }
  .top{
    padding: 10px;
    background: rgba(0, 153, 229, .7);
    color: #fff;
    text-align: center;
    border-radius: 2px;
  }
}
@keyframes blockmove {
  from {
    opacity: 0;
    transform: translateY(0);
    background-color: rgba(255, 255, 255, 0.1);
  }
  to {
    opacity: 1;
    transform: translateY(-400px);
    background-color: rgba(255, 255, 255, 0.6);
  }
}
</style>
